module.exports = __webpack_public_path__ + "img/Earabia-Website-Logo-768x682.e78b5a78.png";